import { Sparkles } from "lucide-react";
import type { SVGAttributes } from "react";

export default function AppLogoIcon(props: SVGAttributes<SVGElement>) {
  return <Sparkles className="text-primary-foreground h-5 w-5" {...props} />;
}
